module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "barbarela.59734f45.jpg";